<template>
  <div>
    <Row>
      <Col span="12" class="info-item">
        <span>用户ID:</span>
        <span>{{baseInfo.user_id}}</span>
      </Col>
      <Col span="12" class="info-item">
        <span>昵称:</span>
        <span>{{baseInfo.nick_name}}</span>
      </Col>
      <Col span="12" class="info-item">
        <span>手机号:</span>
        <span class="important-word">{{baseInfo.mobile}}</span>
      </Col>
      <Col span="12" class="info-item" v-if="baseInfo.company_id>0">
        <span>所属车队:</span>
        <span class="important-word">{{baseInfo.company_name}}</span>
      </Col>
      <Col span="12" class="info-item">
        <span>性别:</span>
        <span>{{baseInfo.gender}}</span>
      </Col>
      <Col span="12" class="info-item">
        <span>用户类型:</span>
        <span>{{baseInfo.user_type_name}}</span>
      </Col>
      <Col span="12" class="info-item">
        <span>真实姓名:</span>
        <span>{{baseInfo.real_name}}</span>
      </Col>
      <Col span="12" class="info-item">
        <span>身份证号:</span>
        <span>{{baseInfo.id_card}}</span>
      </Col>
      <Col span="12" class="info-item" v-if="baseInfo.company_id === 0">
        <span>推荐上级:</span>
        <span>
          <a @click.stop="reloadPage(baseInfo.pid)" v-if="baseInfo.pid > 0">
            {{baseInfo.pname || ''}}
            <Icon type="ios-search" />
          </a>
        </span>
      </Col>
      <Col span="12" class="info-item">
        <span>注册时间:</span>
        <span>{{baseInfo.create_time}}</span>
      </Col>

      <template v-if="baseInfo.user_type === 1">
        <!--<Col span="12" class="info-item">
          <span>是否会员:</span>
          <span>{{baseInfo.is_vip ? '是' : '否'}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>会员到期时间:</span>
          <span>{{baseInfo.vip_end_time}}</span>
        </Col>-->
        <Col span="12" class="info-item">
          <span>车牌号:</span>
          <span class="important-word">{{baseInfo.car_number}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>车型:</span>
          <span>{{baseInfo.car_model}}</span>
        </Col>
        <Col span="24" class="info-item">
          <span>车辆图片:</span>
          <span v-if="baseInfo.car_img">
            <viewer :images="baseInfo.car_img">
              <img v-for="item in baseInfo.car_img" :src="item" style="width: 30px;height: 30px;margin-left: 5px">
            </viewer >
          </span>
          <span v-else>
            尚未上传
          </span>
        </Col>
      </template>

      <template v-if="baseInfo.user_type === 2">
        <Col span="12" class="info-item">
          <span>油站名称:</span>
          <span class="important-word">{{baseInfo.gas_name}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>油站地址:</span>
          <span>{{baseInfo.gas_address}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>油品来源:</span>
          <span>{{baseInfo.private_gas_source}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>营业时间:</span>
          <span>{{baseInfo.work_start_time}} - {{baseInfo.work_end_time}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>联系人:</span>
          <span>{{baseInfo.contact_user}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>联系电话:</span>
          <span>{{baseInfo.contact_mobile}}</span>
        </Col>
        <Col span="12" class="info-item">
          <span>油价:</span>
          <span class="important-word">{{baseInfo.price}}</span>
        </Col>
      </template>

    </Row>

    <Tabs v-if="baseInfo.user_type === 1">
      <TabPane label="订单列表">
        <pageTable tabelRef="orderTable"
                   :tableTitle="orderTableColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.baseInfo.user_id}"
                   tableApi="admin/order/getUserOrder"
        >
        </pageTable>
      </TabPane>

      <TabPane label="佣金列表" v-if="baseInfo.company_id===0">
        <pageTable tabelRef="commissionTable"
                   :tableTitle="commissionTableColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.baseInfo.user_id,asset_type:'commission'}"
                   tableApi="admin/asset/getUserRecord"
        >
        </pageTable>
      </TabPane>

      <!--<TabPane label="充值会员记录">
        <pageTable tabelRef="memberTable"
                   :tableTitle="memberTableColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.user_id}"
                   tableApi="admin/user/getUserMemberLists"
        >
        </pageTable>
      </TabPane>-->

      <TabPane label="推广列表" v-if="baseInfo.company_id===0">
        <pageTable tabelRef="memberTable"
                   :tableTitle="friendColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.baseInfo.user_id}"
                   tableApi="admin/user/getMyFriend"
        >
        </pageTable>
      </TabPane>
    </Tabs>

    <Tabs v-if="baseInfo.user_type === 2">
      <TabPane label="订单列表" v-if="baseInfo.company_id===0">
        <pageTable tabelRef="orderTable"
                   :tableTitle="orderTableColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.baseInfo.user_id}"
                   tableApi="admin/order/getUserOrder"
        >
        </pageTable>
      </TabPane>

      <TabPane label="订单列表" v-if="baseInfo.company_id>0">
        <pageTable tabelRef="orderTable"
                   :tableTitle="fleetOrderTableColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.baseInfo.user_id}"
                   tableApi="admin/order/getUserOrder"
        >
        </pageTable>
      </TabPane>

      <TabPane label="油站列表">
        <pageTable tabelRef="gasTable"
                   :tableTitle="gasTableColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.baseInfo.user_id}"
                   tableApi="admin/gas/getPrivateStation"
        >
        </pageTable>
      </TabPane>

      <TabPane label="佣金列表">
        <pageTable tabelRef="commissionTable"
                   :tableTitle="commissionTableColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.baseInfo.user_id,asset_type:'commission'}"
                   tableApi="admin/asset/getUserRecord"
        >
        </pageTable>
      </TabPane>

      <TabPane label="推广列表">
        <pageTable tabelRef="memberTable"
                   :tableTitle="friendColumn"
                   :searchData="{}"
                   :tableHeight="300"
                   :defaultSearchParam="{user_id:this.baseInfo.user_id}"
                   tableApi="admin/user/getMyFriend"
        >
        </pageTable>
      </TabPane>
    </Tabs>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "edit",
    components:{pageTable},
    props:{
      baseInfo:{
        type:Object,
        default:null
      },
    },
    data(){
      return {
        orderTableColumn:[
          {title:'ID',key:'order_id',align:'center'},
          {title:'订单类型',key:'oil_station_type_name',align:'center'},
          {title:'总金额',key:'total_price',align:'center'},
          {title:'数量(升)',key:'litre_num',align:'center'},
          {title:'单价',key:'buy_price',align:'center'},
          {title:'下单时间',key:'create_time',align:'center',width:180},
        ],
        fleetOrderTableColumn:[
          {title:'ID',key:'order_id',align:'center'},
          {title:'订单类型',key:'oil_station_type_name',align:'center'},
          {title:'总金额',key:'total_price',align:'center'},
          {title:'数量(升)',key:'litre_num',align:'center'},
          {title:'单价',key:'buy_price',align:'center'},
          {title:'抽佣',key:'plate_percentage',align:'center'},
          {title:'实付金额',align:'center',render:(h,params)=>{
            return h('span',params.row.total_price - params.row.plate_percentage)
            }},
          {title:'下单时间',key:'create_time',align:'center',width:180},
        ],
        commissionTableColumn:[
          {title:'数据类型',key:'record_type_name',align:'center'},
          {title:'金额',key:'amount',align:'center'},
          {title:'消费前数量',key:'before_amount',align:'center'},
          {title:'消费后数量',key:'after_amount',align:'center'},
          {title:'发生时间',key:'create_time',align:'center'},
        ],
        memberTableColumn:[
          {title: '充值月数',key: 'month',align: "center"},
          {title: '支付金额',key: 'price',align: "center"},
          {title: '开始日期',key: 'start_day',align: "center"},
          {title: '结束日期',key: 'end_day',align: "center"},
          {title: '微信流水',key: 'trade_no',align: "center"},
          {title: '充值时间',key: 'create_time',align: "center"},
        ],
        friendColumn:[
          {title: '用户ID',key: 'user_id',align: "center"},
          {title: '用户类型',key: 'type_name',align: "center"},
          {title: '手机号',key: 'mobile',align: "center"},
          {title: '昵称',key: 'nick_name',align: "center"},
          {title: '注册时间',key: 'create_time',align: "center"},
          {title: '查看',render:(h,params)=>{
            if (params.row.user_type !== 0){
              return h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.reloadPage(params.row.user_id)}}},'查看')
            }else {
              return  '';
            }
            }},
        ],
        gasTableColumn: [
          {title: 'ID',key: 'station_id',align: "center"},
          {title: '油站名称',key: 'gas_name',align: "left"},
          {title: '地址',key: 'gas_address',align: "center"},
          {title: '油品来源',key: 'private_gas_source',align: "center"},
          {title: '营业时间',align: "center",render:(h,params)=>{
              return h('div',`${params.row.work_start_time} - ${params.row.work_end_time}`)
            }},
          {title: '联系人',key:'contact_user',align: "center"},
          {title: '联系电话',key:'contact_mobile',align: "center"},
          {title: '油价',key: 'price',align: "center",},
          {title: '状态',align: "center",render:(h,params)=>{
              let status = parseInt(params.row.gas_status)
              if (status === 1){
                return h('span','正常')
              }else if(status === 5){
                return h('span',{style:{color:'blue'}},'待审核')
              }else{
                return h('span',{style:{color:'red'}},'禁用')
              }
            }},
        ],
      }
    },
    methods:{
      reloadPage(user_id){
        this.$parent.$parent.reloadPage(user_id)
      }
    },
    mounted() {

    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
